export default {
  ORANGE: '#f68e56',
  RED: '#EB0045',
  DARKBLUE: '#00adee',
  BLUE: '#00adee',
  BLACK: '#343a3f',
  DARK: '#4d5256',
};